import { User } from "../types";

export type SignupFormFields = {
  name: string;
  email: string;
  password: string;
  birth_date: string;
  phone: string;
};

/**
 * Payload alinhado a POST /users/register/ e ao modal de profissional.
 */
export function buildRegisterPayload(
  fields: SignupFormFields,
  options?: { is_professional?: boolean; color?: string; photo?: string },
): Partial<User> & { password: string } {
  const phoneDigits = fields.phone.replace(/\D/g, "");
  return {
    name: fields.name.trim(),
    email: fields.email.trim().toLowerCase(),
    password: fields.password,
    birth_date: fields.birth_date,
    phone: phoneDigits,
    is_professional: options?.is_professional ?? false,
    color: options?.color ?? "",
    photo: options?.photo ?? "",
  };
}
